import { Css, useModal } from "@homebound/beam";
import { Link } from "react-router-dom";
import { FormattedDate } from "src/components";
import {
  BidPackagesPage_AvailableUpdateFragment,
  BidPackagesPage_AvailableUpdateProductOfferingFragment,
} from "src/routes/bids/components/BidUpdatesAvailable.generated";
import { renderListItem } from "src/routes/libraries/versioning/VersionHistoryUtils";
import { createDevelopmentProductOfferingUrl, createProjectProductOfferingUrl } from "src/RouteUrls";
import { sanitizeHtml } from "src/utils";

export function ReadyPlanSourceSection({ update }: { update: BidPackagesPage_AvailableUpdateFragment }) {
  const { tlivs, rplvs } = update.updateStats;
  const { closeModal } = useModal();
  // The source or a bid update will always be a product offering
  const productOffering = update.source.readyPlan as BidPackagesPage_AvailableUpdateProductOfferingFragment;
  return (
    <div>
      <div data-testid="planInfo" css={Css.sm.df.fdr.gap1.$}>
        <span css={Css.sm.$}>{update.source?.readyPlan.name} </span>
        <Link
          to={
            productOffering.development
              ? createDevelopmentProductOfferingUrl(
                  productOffering.development.id,
                  update.source.readyPlan.id,
                  update.source.id,
                )
              : createProjectProductOfferingUrl(
                  productOffering.project!.id,
                  update.source.readyPlan.id,
                  update.source.id,
                )
          }
          onClick={closeModal}
        >
          <span>v{update.source?.version} - </span>
        </Link>
        <span css={Css.gray700.$}>
          <FormattedDate date={update.createdAt} dateFormatStyle="long" />
        </span>
      </div>
      {update.source?.versionNotes && (
        <div
          data-testid="versionNotes"
          css={Css.gray700.sm.$}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(update.source.versionNotes || ""),
          }}
        />
      )}
      <ul css={Css.m0.gray700.$}>
        <>
          {/* Takeoff Items */}
          {renderListItem(tlivs.added, "Added", "takeoff item")}
          {renderListItem(tlivs.removed, "Removed", "takeoff item")}
          {renderListItem(tlivs.updated, "Modified", "takeoff item")}
          {/* Plan Locations */}
          {renderListItem(rplvs.added, "Added", "location")}
          {renderListItem(rplvs.removed, "Removed", "location")}
          {renderListItem(rplvs.updated, "Modified", "location")}
        </>
      </ul>
    </div>
  );
}
